import React from 'react';

import { PaymentMethod } from '@order/features/ordering';
import { useFeatureFlag } from '@order/LaunchDarkly';

import { type GiftCardCheckoutFormFieldRules, type GiftCardCheckoutFormReturn } from '../../form';
import { GiftCardCheckoutFormV2 } from './GiftCardCheckoutFormV2';
import { GiftCardCheckoutFormV3 } from './GiftCardCheckoutFormV3';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardCheckoutForm = (props: GiftCardCheckoutFormProps) => {
  const isPollingEnabled = useFeatureFlag('CELS-4828-gift-card-payment-state-polling-enabled'); // prettier-ignore

  if (isPollingEnabled) {
    return <GiftCardCheckoutFormV3 {...props} />;
  }

  return <GiftCardCheckoutFormV2 {...props} />;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardCheckoutFormProps = {
  purchaseAttempt: number;
  incrementPurchaseAttempt: () => void;
  form: GiftCardCheckoutFormReturn;
  rules: GiftCardCheckoutFormFieldRules;
  paymentMethods: readonly PaymentMethod[];
  submitForm: () => Promise<void>;
  sectionTitles?: {
    amount: string;
    details: string;
    deliveryDate: string;
    deliveryMethod: string;
    recipientEmail: string;
    paymentMethod: string;
  };
};
